import type { typeEnvironments } from '../interfaces';

export type DataDogConfig = {
  applicationId: string;
  clientToken: string;
  env: typeEnvironments;
};

export const initializeDataDog = async (configuration: DataDogConfig) => {
  if (!window) {
    return;
  }

  if (configuration.env === 'dev') {
    return;
  }
  
  if (window.DD_RUM && window.DD_LOGS) {
    return;
  }

  try {
    const datadogRum = (await import('@datadog/browser-rum')).datadogRum;
    datadogRum.init({
      applicationId: configuration.applicationId,
      clientToken: configuration.clientToken,
      site: 'datadoghq.eu',
      service: 'custom-made-configurator-v2',
      env: configuration.env,
      // Specify a version number to identify the deployed version of your application in Datadog
      // version: '1.0.0',
      sessionSampleRate: 100,
      sessionReplaySampleRate: configuration.env === 'prd' ? 100 : 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
    });

    const datadogLogs = (await import('@datadog/browser-logs')).datadogLogs;
    datadogLogs.init({
      clientToken: configuration.clientToken,
      env: configuration.env,
      service: 'custom-made-configurator-v2',
      sessionSampleRate: 100,
      site: 'datadoghq.eu',
      forwardErrorsToLogs: true,
    })
  } catch (error) {
    console.error(error);
  }
};
